export default function validate(form) {
  let allErrors = {};
  let allValidFields = {};

  const regexString = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
  const regexNumber = /^[0-9]*$/;

  if (!form.name.trim()) {
    allErrors.name = 'Necesitamos tu nombre para continuar';
  } else if (form.name.trim().length < 3 && regexString.test(form.name.trim())) {
    allErrors.name = 'El nombre debe tener 3 o más letras';
  } else if (!regexString.test(form.name.trim())) {
    allErrors.name = 'El nombre sólo puede tener letras y espacios en blanco';
  } else {
    allValidFields.name = true;
  }

  if (!form.age.trim()) {
    allErrors.age = 'Necesitamos tu edad para continuar';
  } else if (!regexNumber.test(form.age.trim())) {
    allErrors.age = 'La edad sólo puede tener números';
  } else if (form.age < 21) {
    allErrors.age = 'Aseguramos a mayores de 21 años';
  } else if (form.age > 75) {
    allErrors.age = 'Aseguramos a menores de 76 años';
  } else {
    allValidFields.age = true;
  }

  if (!form.phone.trim()) {
    allErrors.phone = 'Necesitamos tu teléfono para continuar';
  } else if (form.phone.trim().length < 10 && regexNumber.test(form.phone.trim())) {
    allErrors.phone = 'El teléfono debe tener mínimo 10 números';
  } else if (!regexNumber.test(form.phone.trim())) {
    allErrors.phone = 'El teléfono sólo puede tener números';
  } else {
    allValidFields.phone = true;
  }

  return { allErrors, allValidFields };
}
